import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// *DICCIONARIOS
import { moduloSeguridad } from '../../diccionarios/seguridadModulo';
// *COMPONENTES
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AgGridAngular } from 'ag-grid-angular';
// *SERVICIOS
import { RolService } from '../../services/rol.service';
import { RolSesionService } from '../../services/rol-sesion.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.css']
})
export class RolComponent implements OnInit {

  titulo: string;
  textoBuscar: string;
  formulario: FormGroup;
  formularioAgregarRol: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;
  loading: boolean = false;
  mostrarGridLista: boolean = true;

  @ViewChild('agGrid') agGrid: AgGridAngular;
  frameworkComponents: any;

  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  columnDefsRol: any[];
  rowDataRol: any[];
  rowSelectionRol: any;
  gridApiRol: any;
  gridColumnApiRol: any;

  DAT_BTNS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_TITULOS: any;

  textBoton: string;
  diccionarioModulo: any = {};
  cmbListaSession: any[];


  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _rol: RolService,
    private _rolSesion: RolSesionService
  ) {
    this.diccionarioModulo = moduloSeguridad;
  }

  ngOnInit() {
    this.DAT_BTNS = moduloSeguridad.button.buttonsNombre;
    this.DAT_MSG = moduloSeguridad.mensajes;
    this.DAT_BTNCSS = moduloSeguridad.button.buttonsCss;
    this.DAT_TITULOS = moduloSeguridad.titulos.rol;

    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      descripcion: ['', [Validators.required, Validators.maxLength(50)]]
    });

    this.formularioAgregarRol = this.fb.group({
      rolId: ['', [Validators.required]],
      sesionId: ['', [Validators.required, Validators.maxLength(50)]]
    });
    this.girdComponent();
    this.getAllRoles();
  }

  // *FUNCIONES
  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'DESCRIPCION',
        field: 'descripcion',
        sortable: true,
        filter: true,
        width: 400
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarRol.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 170,
        cellRendererParams: {
          onClick: this.agregarRol.bind(this),
          label: 'Sesiones',
          colorBoton: this.DAT_BTNCSS.warning
        }
      }
    ];
    this.rowSelection = 'single';

    this.columnDefsRol = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarLineaRol.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
      {
        headerName: 'ROL',
        field: 'rolDescripcion',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'SESION',
        field: 'sesionDescripcion',
        sortable: true,
        filter: true,
        width: 250
      }
    ];
    this.rowSelectionRol = 'single';
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.formulario.reset();
  }

  editarRol({ rowData }) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.formulario.setValue(rowData);
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarRolId();
      } else {
        this.guardarRol();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  agregarRol({ rowData }) {
    this.editableForm = false;
    this.mostrarFormulario = true;
    this.formularioAgregarRol.get('rolId').setValue(rowData.id);
    this.obtenerSesiones();
    this.obtenerSesionesByRol(rowData.id);
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  // *SERVICIOS
  getAllRoles() {
    this.loading = true;
    this._rol.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._rol.eliminarRolId(rowData.id),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
      console.log(res);
    });
  }

  guardarRol() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._rol.guardarRol(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllRoles();
      this.regresar();
    });
  }

  actualizarRolId() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._rol.actualizarRolId(this.formulario.getRawValue()),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllRoles();
      this.regresar();
    });
  }

  obtenerSesiones() {
    this._rol.getAllSessiones().subscribe((resp) => {
      this.cmbListaSession = resp;
    },(err)=>{
      this.cmbListaSession = [];
    });
  }

  obtenerSesionesByRol(innIdRol) {
    this._rol.getSesionesByRol(innIdRol).subscribe((resp) => {
      this.rowDataRol = resp;
    }, (err) => {
      this.rowDataRol = [];
    });
  }

  accionesAgregarRoles(event) {
    if (event === 'guardar') {
      this._util.confirmarSincronoPromesa(
        {
          title: this.DAT_MSG.guardar,
          text: ``,
          action: this.DAT_BTNS.guardar,
          funcion: this._rolSesion.guardarRolSesion(this.formularioAgregarRol.getRawValue()),
          loading: true,
          context: this,
          regresarForm: false
        }
      ).then((res: any) => {
        this.obtenerSesionesByRol(this.formularioAgregarRol.get('rolId').value);
      }, (err) => {
        this._util.mensajeErrorVisto(err.error.mensaje, false, 1500);
      });
    } else {
      this.mostrarFormulario = false;
      this.mostrarGridLista = true;
      this.regresar();
    }
  }

  eliminarLineaRol({ rowData }) {
    this._util.confirmarSincronoPromesaSinActions(
      {
        title: 'Esta seguro que desea eliminar el siguiente registro ( ' + rowData.sesionDescripcion + ')',
        text: '',
        action: '',
        msn: 'Eliminada'
      }
    ).then((resp: any) => {
      this._rolSesion.eliminarRolSesionId(rowData.rolId, rowData.sesionId).subscribe((resp) => {
        this.obtenerSesionesByRol(rowData.rolId);
        this._util.mensajeOKVisto('sesion eliminada (' + rowData.sesionDescripcion + ')', false, 1500);
      });
    });
  }

}
